import {UI} from "../../../../stem-core/src/ui/UIBase.js";
import {BasePanelPage, BasePanelPageStyle} from "../../PanelPage";
import {iFrameState} from "../../../services/IFrameState";
import {MerchantButton} from "../../../common/MerchantButton";
import {Messages} from "../../../Messages";
import {MessageElement} from "../../../widget/ui/MessageElement";
import {Flow} from "../../initializeFlows";
import {styleRuleInherit} from "../../../../stem-core/src/ui/Style.js";
import {registerStyle} from "../../../../stem-core/src/ui/style/Theme.js";

export class ProductPanel extends UI.Element {
    render() {
        const {product} = this.options;
        return [
            <h1>{product.name}</h1>,
            <MessageElement message={product.description} />,
            <div>Price: {product.getAmount()}</div>,
            product.requiresAddress && <div>Address Required</div>,
            <MerchantButton
                label={Messages.shopBuyNow}
                onClick={() => Flow.shop.selectProduct(product)}
            />,
            <hr/>
        ]
    }
}

export class ShopPanelStyle extends BasePanelPageStyle {
    @styleRuleInherit
    content = {
        ...this.themeProps.PANEL_PAGE_STYLE,
    };
}

@registerStyle(ShopPanelStyle)
export class ShopPanel extends BasePanelPage {
    render() {
        const products = iFrameState.getProducts();
        return products.length === 0 ? ["No products available"] : products.map(product => <ProductPanel product={product} />);
    }
}
